import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import i18n, { ensureAdminTranslations, maybeLoadAdminFromPath } from '../lib/i18n'

export default function I18nInitializer() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Initialize i18n on client side only
    if (typeof window !== 'undefined' && !i18n.isInitialized) {
      i18n.init()
    }
  }, [])

  useEffect(() => {
    maybeLoadAdminFromPath(pathname)
    if (pathname.startsWith('/admin')) {
      void ensureAdminTranslations()
    }
  }, [pathname])

  return null
}
